import { useEffect, useState } from "react";
import {
  MUpdatePrice,
  MUpdatePriceProduct
} from "../../../../../../server/routes/logUpdated/price/types";
import getToken from "../../../../getters/getToken";
import useRejectWithMessage from "../../../../hooks/useRejectWithMessage";
import { getLogUpdatedPriceProductsList } from "../../../../requests";
import useExpanded from "../../Provider/hooks/useExpanded";
import useFilterValue from "../../Provider/hooks/useFilterValue";

const useTable = (logId: MUpdatePrice["id"]) => {
  const [isLoading, updateLoadingStatus] = useState<boolean>(false);
  const [products, updateProducts] = useState<MUpdatePriceProduct[]>([]);
  const { value: type } = useFilterValue("type");
  const { value: productId = "" } = useFilterValue("productId");
  const { value: productArticle = "" } = useFilterValue("productArticle");
  const token = getToken();
  const { update } = useExpanded(logId);
  const handlerReject = useRejectWithMessage(
    "Ошибка загрузки списка товаров",
    () => {
      update(false);
    }
  );

  useEffect(() => {
    updateLoadingStatus(true);
    getLogUpdatedPriceProductsList(token, logId, {
      type,
      productId: productId?.length > 0 ? productId : undefined,
      productArticle: productArticle?.length > 0 ? productArticle : undefined,
    })
      .then(({ list }) => {
        updateProducts(list);
      })
      .catch(handlerReject)
      .finally(() => {
        updateLoadingStatus(false);
      });
  }, [logId]);
  return { isLoading, products };
};

export default useTable;
